<style lang="postcss">
  :global(.navBarLink) {
    @apply py-2 px-4 text-white font-semibold rounded-lg transform transition duration-500 focus:outline-none;
  }
  :global(.activeLink) {
    @apply scale-110;
    --borderWidth: -50px;
  }

  :global(.activeLink:hover) {
    --borderWidth: 3px;
    position: relative;
  }

  :global(.activeLink:after) {
    background-image: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #d51be2, rgb(180, 78, 132));
    @apply blur;
    content: '';
    position: absolute;
    top: calc(-1 * var(--borderWidth));
    left: calc(-1 * var(--borderWidth));
    height: calc(100% + var(--borderWidth) * 2);
    width: calc(100% + var(--borderWidth) * 2);
    border-radius: calc(4 * var(--borderWidth));
    z-index: -1;
    animation: animatedgradient 3s ease alternate infinite;
    background-size: 300% 300%;
  }

  :global(.activeLink:after) {
    transition: height 2.2s linear, inline-size 2.2s linear, inset 2.2s linear;
  }

  :global(.activeLink:hover:after) {
    transition: inherit;
  }


  @keyframes animatedgradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  .navBarLink:not(.activeLink) {
    @apply hover:text-pink-500 hover:scale-110;
  }
</style>

<a href="{href}" class="{className}">
  <slot></slot>
</a>

<script>
  export let href;
  export let className;
</script>